import { render, staticRenderFns } from "./praies-details.vue?vue&type=template&id=66dbc9a7&scoped=true"
import script from "./praies-details.vue?vue&type=script&lang=js"
export * from "./praies-details.vue?vue&type=script&lang=js"
import style0 from "./praies-details.vue?vue&type=style&index=0&id=66dbc9a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbc9a7",
  null
  
)

export default component.exports